module.exports = __webpack_public_path__ + "f9c54402b8191ab04d6717fe7449cd51.png";